<template>
  <div class="page">
    <!-- 顶部 -->
    <div class="w-1-1 h-48px flex align-center m-t-29px m-b-39px">
      <img
        src="../assets/logo.png"
        alt=""
        class="w-173px h-35px m-r-187px pointer"
        @click="go('/')"
      />
      <el-input
        placeholder="字由个人会员"
        v-model="input"
        class="w-719px h-49px"
        @keydown.enter.native="go('/search', { search: input })"
      >
        <el-button slot="prepend" icon="el-icon-search"></el-button>
        <div
          slot="append"
          class="w-84px flex justify-center align-center pointer"
          @click="go('/search', { search: input })"
        >
          搜索
        </div>
      </el-input>

      <div
        @click="loginVisibleDailog = true"
        class="
          w-148px
          h-48px
          bdrs-24px
          gold-border-1px
          m-l-32px
          flex
          align-center
          pointer
        "
      >
        <img
          class="pointer w-18px h-17px m-l-27px"
          src="../assets/shopping-cart_gold.png"
          alt="shop"
        />
        <span class="font14 font-weight-500 l-h-21px gold m-l-5px"
          >我的购物车</span
        >
      </div>
    </div>

    <div class="flex">
      <!-- 分类 -->
      <div
        class="
          w-342px
          h-389px
          bdrs-32px
          bg-gray
          border-box
          p-t-19px p-l-31px p-r-31px p-b-19px
        "
      >
        <div class="black font18 font-weight-500 l-h-27px m-b-32px">分类</div>
        <div
          v-for="(item, index) in types"
          :key="index"
          class="gray font15 font-weight-500 l-h-22px m-b-11px"
        >
          <span class="m-r-8px">{{ item.name }}：</span>
          <span
            v-for="(childItem, childIndex) in item.child"
            :key="childIndex"
            class="m-r-8px pointer"
            @click="jump(childItem.link)"
            >{{ childItem.name }}</span
          >
        </div>
      </div>
      <!-- 轮播 -->
      <div class="w-900px m-l-18px bdrs-32px">
        <div class="h-76px flex align-center">
          <span
            :class="setActiveItem === 0 ? 'gold' : ''"
            class="pointer black font18 font-weight-500 l-h-27px"
            @click="changeCurrentItem(0)"
            >商城热卖</span
          >
          <div class="vertical-line m-r-23px m-l-23px"></div>
          <span
            :class="setActiveItem >= 1 && setActiveItem <= 2 ? 'gold' : ''"
            class="pointer black font18 font-weight-500 l-h-27px"
            @click="changeCurrentItem(1)"
            >限时特价</span
          >
          <div class="vertical-line m-r-23px m-l-23px"></div>
          <span
            :class="setActiveItem === 3 ? 'gold' : ''"
            class="pointer black font18 font-weight-500 l-h-27px"
            @click="changeCurrentItem(3)"
            >精品推荐</span
          >
          <div class="vertical-line m-r-23px m-l-23px"></div>
          <span
            :class="setActiveItem >= 4 ? 'gold' : ''"
            class="pointer black font18 font-weight-500 l-h-27px"
            @click="changeCurrentItem(4)"
            >新品推荐</span
          >
        </div>
        <el-carousel height="313px" @change="carouselChange" ref="carousel">
          <el-carousel-item
            v-for="(item, index) in slideList"
            :key="index"
            :name="String(index)"
          >
            <img :src="item.img" class="bdrs-32px pointer" @click="go(item.link)" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <!-- 首页部分标题 -->
    <div>
      <div
        class="
          font25
          font-weight-500
          l-h-37px
          black
          flex
          justify-center
          m-t-63px m-b-13px
        "
      >
        商城热卖
      </div>
      <div
        class="
          flex
          justify-center
          font18
          font-weight-500
          l-h-27px
          gray
          m-b-61px
        "
      >
        精选爆款 热销推荐
      </div>
    </div>

    <!-- 商品卡片 -->
    <div class="goods-wrapper flex">
      <div
        class="goods-card m-r-35px relative"
        v-for="(item, index) in goodsList"
        :key="index"
      >
        <img :src="item.main_img" alt="" @click="go('detail', item)" />
        <div class="goods-title">{{ item.name }}</div>
        <div class="goods-day">{{ item.style }}</div>
        <div class="goods-price flex">
          <span class="price font25">{{ item.price }}</span>
          <span class="unit">元</span>
          <div class="pay flex absolute r-14px" @click="loginVisibleDailog = true">
            <img src="../assets/shopping-cart_white.png" alt="" />
            <span>立即购买</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="flex justify-center m-b-56px m-l--93px">
      <el-pagination
        layout="prev, pager, next"
        :total="goods.length"
        :page-size="pagination.size"
        :current-page="pagination.page"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 登录弹窗 -->
    <loginDialog :visible.sync="loginVisibleDailog" />
  </div>
</template>

<script>
import loginDialog from "../components/login.vue";
import typesOrigin from "../static/types.json";
import slideOrigin from "../static/slide.json";
import goodsOrigin from "../static/goods.json";
export default {
  components: {
    loginDialog,
  },
  data() {
    return {
      input: "",
      loginVisibleDailog: false,
      types: JSON.parse(JSON.stringify(typesOrigin)),
      slideList: JSON.parse(JSON.stringify(slideOrigin)),
      setActiveItem: 0,
      goods: JSON.parse(JSON.stringify(goodsOrigin)),
      goodsList: [],
      pagination: {
        size: 15,
        page: 1,
      },
    };
  },
  mounted() {
    this.handleCurrentChange(this.pagination.page);
  },
  methods: {
    // 轮播图滑动
    carouselChange(index) {
      this.setActiveItem = index;
      console.log(index);
    },
    // 手动改变轮播图
    changeCurrentItem(index) {
      this.$refs.carousel.setActiveItem(index);
    },
    go(path, query) {
      this.$router.push({
        path,
        query: query,
      });
    },
    jump(link) {
      location.href = link;
    },
    handleCurrentChange(pages) {
      this.pagination.page = pages;
      const { page, size } = this.pagination;
      this.goodsList = this.goods.slice((page - 1) * size + 1, page * size + 1);
    },
  },
};
</script>

<style lang="less" scoped>
:deep(.el-input__inner) {
  height: 49px;
  border-radius: 24px 0px 0px 24px !important;
  padding-left: 49px;
  border: 1px solid rgba(195, 152, 96, 1);
  width: 594px;
}
:deep(.el-input-group__append) {
  background: rgba(195, 152, 96, 1);
  border-radius: 0px 24px 24px 0px;
  font-size: 21px;
  font-weight: 300;
  line-height: 31px;
  color: rgba(255, 255, 255, 1);
}
:deep(.el-input-group__prepend) {
  padding: 0;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  position: relative;
  left: 39px;
}
.pointer {
  cursor: pointer;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
.r-14px {
  right: 14px;
}
.flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.align-center {
  align-items: center;
}
.border-box {
  box-sizing: border-box;
}
.gold {
  color: rgba(195, 152, 96, 1) !important;
}
.black {
  color: rgba(105, 104, 115, 1);
}
.gray {
  color: rgba(151, 150, 158, 1);
}
.bg-gray {
  background: rgba(247, 249, 250, 1);
}
.gold-border-1px {
  border: 1px solid rgba(195, 152, 96, 1);
}
.font14 {
  font-size: 14px;
}
.font15 {
  font-size: 15px;
}
.font18 {
  font-size: 18px;
}
.font25 {
  font-size: 25px;
}
.font-weight-500 {
  font-weight: 500;
}
.l-h-21px {
  line-height: 21px;
}
.l-h-22px {
  line-height: 22px;
}
.l-h-27px {
  line-height: 27px;
}
.l-h-37px {
  line-height: 37px;
}
.m-t-29px {
  margin-top: 29px;
}
.m-t-63px {
  margin-top: 63px;
}
.m-l--93px {
  margin-left: -93px;
}
.m-l-5px {
  margin-left: 5px;
}
.m-l-7px {
  margin-left: 7px;
}
.m-l-18px {
  margin-left: 18px;
}
.m-l-23px {
  margin-left: 23px;
}
.m-l-27px {
  margin-left: 27px;
}
.m-l-32px {
  margin-left: 32px;
}
.m-r-8px {
  margin-right: 8px;
}
.m-r-10px {
  margin-right: 10px;
}
.m-r-23px {
  margin-right: 23px;
}
.m-r-187px {
  margin-right: 187px;
}
.m-b-11px {
  margin-bottom: 11px;
}
.m-b-13px {
  margin-bottom: 13px;
}
.m-b-32px {
  margin-bottom: 32px;
}
.m-b-39px {
  margin-bottom: 39px;
}
.m-b-56px {
  margin-bottom: 56px;
}
.m-b-61px {
  margin-bottom: 61px;
}
.p-t-19px {
  padding-top: 19px;
}
.p-l-31px {
  padding-left: 31px;
}
.p-r-31px {
  padding-right: 31px;
}
.p-b-19px {
  padding-bottom: 19px;
}
.w-1-1 {
  width: 100vw;
}
.w-18px {
  width: 18px;
}
.w-38px {
  width: 38px;
}
.w-84px {
  width: 84px;
}
.w-124px {
  width: 124px;
}
.w-148px {
  width: 148px;
}
.w-173px {
  width: 173px;
}
.w-342px {
  width: 342px;
}
.w-719px {
  width: 719px;
}
.w-900px {
  width: 900px;
}
.h-17px {
  height: 17px;
}
.h-35px {
  height: 35px;
}
.h-48px {
  height: 48px;
}
.h-49px {
  height: 49px;
}
.h-76px {
  height: 76px;
}
.h-201px {
  height: 201px;
}
.h-389px {
  height: 389px;
}
.bdrs-24px {
  border-radius: 24px;
}
.bdrs-32px {
  border-radius: 32px;
}
.page {
  width: 1440px;
  margin: 0 auto;
  box-sizing: border-box;
  padding-left: 93px;
  .search {
    border-radius: 0px 24px 24px 0px;
    border: 1px solid rgba(227, 227, 227, 1);
  }
  .vertical-line {
    width: 0px;
    height: 16.94px;
    opacity: 1;
    border: 1px solid rgba(224, 224, 224, 1);
  }
  .goods-wrapper {
    width: 1440px;
    min-height: 561px;
    margin-top: 40px;
    flex-wrap: wrap;

    .goods-card {
      width: 222px;
      height: 329px;
      border: 1px solid rgba(221, 221, 223, 1);
      margin-bottom: 56px;

      img {
        width: 222px;
        height: 222px;
        cursor: pointer;
      }

      .goods-title {
        font-size: 18px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 27px;
        color: rgba(49, 49, 49, 1);
        text-align: left;
        vertical-align: top;
        margin-left: 15px;
        margin-top: 7px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .goods-day {
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 21px;
        min-height: 21px;
        color: rgba(151, 150, 158, 1);
        text-align: left;
        margin-left: 15px;
      }

      .goods-price {
        height: 38px;
        align-items: center;
        margin-left: 15px;

        .price {
          line-height: 30px;
          color: rgba(193, 58, 54, 1);
        }

        .unit {
          line-height: 21px;
          color: rgba(151, 150, 158, 1);
          font-size: 10px;
          font-weight: 400;
          letter-spacing: 0px;
          margin-top: 5px;
          margin-right: 32px;
        }

        .pay {
          width: 105px;
          height: 33px;
          border-radius: 17px;
          background: rgba(193, 58, 54, 1);
          align-items: center;

          img {
            width: 17px;
            height: 17px;
            margin-left: 10px;
            margin-right: 8px;
          }

          span {
            font-size: 15px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(255, 255, 255, 1);
            text-align: left;
            vertical-align: top;
            cursor: pointer;
          }
        }
      }
    }

    .m-r-35px {
      margin-right: 35px;
    }
  }
  :deep(.btn-prev) {
    min-width: 24px;
    height: 24px;
    background: rgba(212, 206, 188, 1);
    border-radius: 50px;
    padding: 0;
  }
  :deep(.el-icon-arrow-left::before) {
    color: white;
  }
  :deep(.btn-next) {
    min-width: 24px;
    height: 24px;
    background: rgba(212, 206, 188, 1);
    border-radius: 50px;
    padding: 0;
  }
  :deep(.el-icon-arrow-right::before) {
    color: white;
  }
  :deep(.active) {
    color: #B0A17C;
  }
}
</style>